import { FormLabel, Grid, MenuItem, Select, Skeleton } from "@mui/material";

function GridDdlPlace({ isRequired, titleForm, columns, datahandler, datas, attribute, isLoading }) {
    const dynamiAttribute = attribute;
    if (isRequired) {
        dynamiAttribute["required"] = true;
    }
    const GenerateTemplate = ({ children }) => {
        if (!columns) {
            return (
                <>
                    {children}
                </>
            )
        }
        return (
            <>
                <Grid sx={{ padding: "5px" }} xs={12} xl={columns} lg={columns} sm={12} md={columns}>
                    {children}
                </Grid>
            </>
        )
    }
    const GenerateInput = () => {
        if (isLoading) {
            return (
                <>
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                </>
            )

        }
        return (
            <>
                <FormLabel sx={[{
                    color: "#000000", fontWeight: "bold", marginTop: "15px"
                },
                (isRequired) ?
                    {
                        "::after": {
                            content: '" *Wajib Diisi"',
                            color: "red",
                            fontWeight: "bold",
                            fontStyle: "italic"
                        }
                    } : {}]}>{titleForm}</FormLabel>
                <Select {...attribute} onChange={datahandler} fullWidth>
                    {
                        datas.data.map((data) => {
                            return (
                                <MenuItem key={data[datas.keyName]} value={data[datas.valueName]}>{data[datas.valueName]}</MenuItem>
                            )
                        })
                    }
                </Select>
            </>
        );
    }
    return (
        <>
            <GenerateTemplate>
                {GenerateInput()}

            </GenerateTemplate>
        </>
    )
}
export default GridDdlPlace;